// Shared email regex for wizard validation — one rule for all three wizards.
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

// Five digits matches the input mask in SqmStep; the deep-link parser and the
// step's ready check must agree on it.
export function isValidSquareMeters(value: string): boolean {
  return /^\d{1,5}$/.test(value) && Number.parseInt(value, 10) > 0;
}
